/**
 * @license Copyright (c) Microsoft Corporation.  All rights reserved.
 */
var SessionStorageExpirableItem = /** @class */ (function () {
    function SessionStorageExpirableItem(createdOn, maxAgeInSecs, value) {
        this.createdOn = createdOn;
        this.maxAgeInSecs = maxAgeInSecs;
        this.value = value;
    }
    SessionStorageExpirableItem.prototype.isExpired = function (when) {
        return (when ? when.getTime() : Date.now()) - this.createdOn.getTime() > this.maxAgeInSecs * 1000;
    };
    SessionStorageExpirableItem.prototype.getExpiration = function () {
        return new Date(this.createdOn.getTime() + this.maxAgeInSecs * 1000);
    };
    SessionStorageExpirableItem.prototype.stringify = function () {
        return JSON.stringify(this);
    };
    SessionStorageExpirableItem.createWith = function (maxAgeInSecs, obj) {
        return new SessionStorageExpirableItem(new Date(), maxAgeInSecs, obj);
    };
    SessionStorageExpirableItem.createWith30MinutesMaxAge = function (obj) {
        return SessionStorageExpirableItem.createWith(60 * 30, obj);
    };
    SessionStorageExpirableItem.parse = function (string) {
        var parsed = JSON.parse(string);
        return new SessionStorageExpirableItem(new Date(parsed.createdOn), parsed.maxAgeInSecs, parsed.value);
    };
    return SessionStorageExpirableItem;
}());
export { SessionStorageExpirableItem };
